import React, {PureComponent} from 'react'
import config from '../../config'
import {
    ListSubheader,
    IconButton,
    List,
    Button,
} from '@material-ui/core'
import PlayArrowRounded from '@material-ui/icons/PlayCircleFilled'
import Player from '../../containers/player'

export default class DiscoveryFeedComponent extends PureComponent {
    componentDidUpdate(prevProps) {
        if (prevProps.currentTrack !== this.props.currentTrack) {
            this.props.hideTally();
        }
    }

    renderItem = (item, index) => {
        return (
            <div
                key={index + item.track_id}
            >
                <div
                    style={{
                        width: 280,
                        borderBottom: '1px solid white',
                        height: 280,
                        position: 'relative',
                    }}
                >
                    <img
                        alt={'cover-art'}
                        style={{position: 'relative'}}
                        src={`${config.cloudinaryPublicUrl}/w_280,h_280,c_scale/${
                            item.cover_art
                            }.jpg`}
                    />
                    <img
                        alt={'cover-art'}
                        style={{position: 'absolute', top: 0, left: 0}}
                        src={`${
                            config.cloudinaryPublicUrl
                            }w_280,h_280,c_scale/mediaImageOverlay_tods2e`}
                    />
                    {index !== undefined
                        ? <IconButton onClick={() => this.props.setCurrentTrack(item)}
                                      style={{color: 'white', position: 'absolute', top: 116, left: 116}}>
                            <PlayArrowRounded fontSize={"large"}/>
                        </IconButton>
                        :
                        <Button
                            variant="contained"
                            color="primary"
                            style={{position: 'absolute', bottom: 10, right: 10}}>
                            Show tally
                        </Button>
                    }
                    <div
                        style={{
                            position: 'absolute',
                            fontWeight: 'bold',
                            color: 'white',
                            fontSize: 12,
                            top: 5,
                            left: 5
                        }}
                    >
                        {index + 1}. {item.artist_name}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            fontStyle: 'italic',
                            fontSize: 10,
                            top: 20,
                            left: 5,
                            color: 'white'
                        }}
                    >
                        {item.track_name.toUpperCase()}
                    </div>
                </div>
            </div>
        )
    };

    setTallyVisibility = () => {
        if (this.props.isShowTally) {
            this.props.hideTally()
        } else {
            this.props.showTally()
        }
    };

    render() {
        const {pendingTracks, currentTrack, isShowTally} = this.props;
        return <div style={{
            height: 550,
            minWidth: 280,
            backgroundColor: 'black',
            scrollbarWidth: 0,
            position: 'relative',

        }}>
            {
                currentTrack
                    ? <>
                        <Button
                            onClick={this.setTallyVisibility}
                            variant="contained"
                            color="primary"
                            style={{position: 'absolute', top: -80, left: 80}}
                        >
                            {isShowTally ? 'Hide' : 'Show'} tally
                        </Button>
                        <Player showTally={isShowTally} currentTrack={currentTrack}/>
                    </>
                    : (
                        <>
                            <List className={"list"}
                                  style={{paddingTop: 0, paddingBottom: 0, overflow: 'scroll', height: 500}}
                                  subheader={
                                      <ListSubheader style={{
                                          backgroundColor: 'black',
                                          textAlign: 'center',
                                          color: 'white',
                                          borderBottom: '1px solid white',
                                      }} component="div" id="nested-list-subheader">
                                          Discovery
                                      </ListSubheader>
                                  }
                            >{pendingTracks.map(this.renderItem)}
                            </List>
                            <div style={{
                                display: 'flex',
                                width: '100%',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                height: 49,
                                backgroundColor: 'black',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                borderTop: '1px solid white',
                            }}>
                                <img alt={"tweedl-logo"} style={{width: 100}} src={require("../../img/tweedlLogoBlueText.png")}/>
                            </div>
                        </>
                    )
            }
        </div>
    }
}